import { render, staticRenderFns } from "./match2023p.vue?vue&type=template&id=aeb5ac30&scoped=true"
import script from "./match2023p.vue?vue&type=script&lang=js"
export * from "./match2023p.vue?vue&type=script&lang=js"
import style0 from "./match2023p.vue?vue&type=style&index=0&id=aeb5ac30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb5ac30",
  null
  
)

export default component.exports